import { Link } from "react-router-dom";
import { PROPERTY_IMAGES_URL } from "../../constants/url";
import { EDIT_PROPERTY_ROUTE } from "../../constants/routes";
import { formatCurrency } from "../../constants/currency";
import { Chip, Typography } from "@mui/material";
import { PROPERTY_STATUSES } from "../../constants/property";
import { RowingTwoTone } from "@mui/icons-material";
import dayjs from "dayjs";

export const AGENCY_PROPERTY_COLUMNS = [
  {
    header: "Picture",
    accessor: "propertyimages",
    Cell: ({ row }) => (
      <img
        src={PROPERTY_IMAGES_URL + row.original.FirstImage}
        alt={"property"}
        style={{ width: "50px", height: "50px" }}
      />
    ),
    size: 30,
  },
  {
    accessorKey: "propertyrefnum",
    header: "Ref No",
    size: 20,
    Cell: ({ row }) => (
      <Chip
        sx={{ cursor: "pointer" }}
        size="small"
        variant="filled"
        component={Link}
        to={EDIT_PROPERTY_ROUTE + row.original.propertyid}
        color={
          PROPERTY_STATUSES.find((item) => item.id === row.original?.pstatus)
            ?.color
        }
        label={row.original.propertyrefnum}
      />
    ),
  },

  { accessorKey: "PropertyPurpose", header: "Purpose", size: 30 },
  { accessorKey: "PropertyType", header: "Type", size: 30 },
  {
    accessorKey: "lastUpdated",
    header: "Last Updated",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.lastUpdated;
      if (!value) return null;

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
  },
  {
    accessorKey: "propertyprice",
    filterFn: "between",
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        textAlign: "center",
      },
    }),
    header: "Price",
    size: 30,
    Cell: ({ row }) => (
      <div style={{ textAlign: "center" }}>
        {formatCurrency(row.original.propertyprice, row.original.countryid)}
      </div>
    ),
  },
  { accessorKey: "bedrooms", filterFn: "between", header: "Beds", size: 30 },
  { accessorKey: "bathrooms", header: "Baths", filterFn: "between", size: 30 },
  { accessorKey: "CityName", header: "City", size: 30 },
  { accessorKey: "permitno", header: "Permit No", size: 20 },
  { accessorKey: "AgentName", header: "Staff", size: 20 },
  { accessorKey: "propertytitle", header: "Title", size: 30 },
  { accessorKey: "SubLocation", header: "Sub Location", size: 30 },
 
  {
    accessorKey: "SubLocation",
    header: "Map Location",
    size: 30,
    Cell: ({ row }) => {
      return (
        <a href={row.original.coordinates} target="_blank" rel="noreferrer">
          {"show"}
        </a>
      );
    },
  },
  { accessorKey: "propertysizesqft", header: "Size (Sqft)", size: 30 },
  { accessorKey: "ownfirstname", header: "Owner Name", size: 30 },
  {
    accessorKey: "mobileno",
    header: "Owner Contact",
    size: 30,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.mobileno}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.mobileno}
      </a>
    ),
  },
];

export const AGENCY_LEAD_PROPERTY_COLUMNS = [
  {
    header: "Picture",
    accessor: "FirstImage",
    Cell: ({ row }) => (
      <img
        src={PROPERTY_IMAGES_URL + row.original.FirstImage}
        alt={"property"}
        style={{ width: "50px", height: "50px" }}
      />
    ),
    size: 30,
  },
  {
    accessorKey: "propertyrefnum",
    header: "Ref No",
    size: 20,
    Cell: ({ row }) => (
      <Chip
        sx={{ cursor: "pointer" }}
        size="small"
        variant="filled"
        component={Link}
        to={""}
        color={
          PROPERTY_STATUSES.find((item) => item.id === row.original.pstatus)
            ?.color
        }
        label={row.original.propertyrefnum}
      />
    ),
  },
  { accessorKey: "PropertyPurpose", header: "Purpose", size: 30 },
  { accessorKey: "PropertyType", header: "Type", size: 30 },
  {
    accessorKey: "propertyprice",
    filterFn: "between",
    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        textAlign: "center",
      },
    }),
    header: "Price",
    size: 30,
    Cell: ({ row }) => (
      <div style={{ textAlign: "center" }}>
        {formatCurrency(row.original.propertyprice, row.original.countryid)}
      </div>
    ),
  },
  { accessorKey: "bedrooms", filterFn: "between", header: "Beds", size: 30 },
  { accessorKey: "bathrooms", header: "Baths", filterFn: "between", size: 30 },
  { accessorKey: "CityName", header: "City", size: 30 },
  { accessorKey: "AgentName", header: "Staff", size: 20 },
  { accessorKey: "propertytitle", header: "Title", size: 30 },
  {
    accessorKey: "propertyaddress",
    header: "Sub Location",
    size: 30,
    Cell: ({ row }) => {
      return (
        <a href={row.original.coordinates} target="_blank" rel="noreferrer">
          {row.original?.sublocation || row.original?.propertyaddress || "show"}
        </a>
      );
    },
  },
  { accessorKey: "propertysizesqft", header: "Size (Sqft)", size: 30 },
  { accessorKey: "ownfirstname", header: "Owner Name", size: 30 },
  { accessorKey: "mobileno", header: "Owner Contact", size: 30 },
];
